<template>
  <div
    v-if="loaded"
    class="matrix-grid-component-container"
  >
    <matrix-grid-table
      :answers="sortedFlashcardAnswers"
      :answered="answered"
      :columns="choiceColumns"
      :flashcard="flashcard"
      :input-type="inputType"
      :headers="flashcard.matrixGridColumnHeaders"
      :matrix-grid-selections="matrixGridSelections"
      :rationales-locked="lockedRationales"
      @handle-answer="handleAnswerInput"
    />
    <matrix-grid-column
      :answers="sortedFlashcardAnswers"
      :answered="answered"
      :flashcard="flashcard"
      :input-type="inputType"
      :headers="choiceHeaders"
      :matrix-grid-selections="matrixGridSelections"
      :rationales-locked="lockedRationales"
      @handle-answer="handleAnswerInput"
    />
  </div>
</template>

<script>
import MatrixGridColumn from '@/components/flashcards/fragments/matrix-grid-column';
import MatrixGridTable from '@/components/flashcards/fragments/matrix-grid-table';

export default {
  name: 'MatrixGrid',
  components: { MatrixGridColumn, MatrixGridTable },
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
    lockedRationales: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
    },
    rawAnswerData: {
      type: Object,
    },
  },
  emits: ['set-raw-answer-data'],
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    allowMultipleAnswers() {
      return this.flashcard.answers.some(a => a.matrixGridCorrect.filter(column => column).length > 1);
    },
    choiceColumns() {
      return this.flashcard.matrixGridColumns - 1;
    },
    choiceHeaders() {
      return [...this.flashcard.matrixGridColumnHeaders].slice(1);
    },
    sortedFlashcardAnswers() {
      return [...this.flashcard?.answers].sort((a,b) => a.sortOrder - b.sortOrder);
    },
    inputType() {
      if (this.allowMultipleAnswers) {
        return 'checkbox';
      } else {
        return 'radio';
      }
    },
    matrixGridSelections() {
      if (this.flashcardState.rawAnswerData) {
        return this.flashcardState.rawAnswerData?.matrixGridSelections;
      }
      return this.rawAnswerData?.matrixGridSelections;
    },
  },
  mounted() {
    this.$watch('flashcard', (newFlash, oldFlash) => {
      if (newFlash.id !== oldFlash?.id) {
        if (!this.flashcardState.rawAnswerData) {
          this.loaded = false;
          this.createGridAnswerData();
          this.loaded = true;
        } else {
          this.loaded = true;
        }
      }
    }, { immediate: true });
  },
  methods: {
    createEmptyColumnAnswers() {
      return new Array(this.choiceColumns).fill(false);
    },
    createGridAnswerData() {
      const answerData = this.flashcard.answers.map(answer => {
        return {
          answerId: answer.id,
          selections: this.createEmptyColumnAnswers(),
        };
      });
      this.$emit('set-raw-answer-data', { matrixGridSelections: answerData });
    },
    handleAnswerInput(params) {
      const { value, answerId, selectionIndex } = params;
      const newAnswers = this.matrixGridSelections.filter(answerObject => answerObject.answerId !== answerId);
      let answers;
      if (this.allowMultipleAnswers) {
        const data = this.matrixGridSelections.find(answerObject => answerObject.answerId === answerId);
        answers = data.selections;
      } else {
        answers = this.createEmptyColumnAnswers();
      }
      answers[selectionIndex] = value;
      newAnswers.push({ answerId, selections: answers });
      this.$emit('set-raw-answer-data', { matrixGridSelections: newAnswers });
    },
  },
};
</script>

<style lang="scss">
.matrix-grid-component-container {

}
</style>
